module.exports = __webpack_public_path__ + "img/faq-black-icon.45cb175c.png";